import { stripeRadius } from './StripeStore';

export const updateStripeRadius = (value) => stripeRadius.update((oldValue) => value);
